import { BiometricType } from '../constants';

export enum TrackingBiometricType {
  IosFace = 'ios_face',
  IosTouch = 'ios_touch',
  AndroidBiometrics = 'android_biometrics',
  Passcode = 'passcode',
}

export enum PageSection {
  BiometricsSuccessEnabledPrompt = 'biometric_success_enabled_prompt',
  BiometricsFailedTooManyTimes = 'biometric_failed_too_many_times',
  LoginWithOtherMethodsSelection = 'login_with_other_methods_selection',
}

export type TrackingDataBiometricPromptProps = {
  biometricType: BiometricType | string;
};

export type TrackingDataFieldBiometricsPrompt = {
  biometric_type: TrackingBiometricType | string;
};

export type TrackingDataReloginBiometricsProps = {
  biometricType: BiometricType | string;
};

export type TrackingDataFieldReloginBiometrics = {
  biometric_type: TrackingBiometricType | string;
};
